angular.module('bb.util').component('bbLoading', {
  transclude: true,
  bindings: {
    hasLoaded: '=',
  },
  controller: LoadingController,
  controllerAs: 'vm',
  template: require('./loading.html'),
});

LoadingController.$inject = ['$scope'];
function LoadingController($scope) {}

export {};
